export const Account = {
    "用户名":"User name",
    "邮箱/手机号":"Email/mobile number",
    "请输入您的邮箱/手机号":"Please enter your email/mobile number",
    "请输入要绑定邮箱手机号":"enter phone or email to bind",
    "请填邮箱/手机号":"Please enter email/mobile number",
    "验证码":"Verification code",
    "请输入验证码":"Please enter the verification code",
    "请输入计算结果":"Please enter the calculation result",
    "提交":"Submit",
    "请输入密码":"Please enter the password",
    "请填写密码":"Please enter the password",
    "确认密码":"Confirm Password",
    "请再次输入":"Please enter again",
    "两次输入的密码不一致请您检查密码":"The two passwords are inconsistent. Please check the password",
    "已发送验证码至":"The verification code has been sent to",
    "注册并登陆":"Register and log in",
    "账号类型错误":"Wrong account type",
    "邮箱账号手机号":"Email/account/mobile number",
    "请输入邮箱手机号":"Please enter your email/mobile number",
    "还没有账号":"Don't have an account yet?",
    "立即注册并绑定":"Register and bind now",
    "注册并绑定":"Register and bind",
    "请检查登录信息":"Please check the login information",
    "没有读取到code_key":"No code_key read",
    "登录失败":"Login failed",
    "请检查密码格式应大于6位":"Please check the password format, which should be greater than 6 digits",
    "两次密码应该相同":"Passwords should be the same twice",
    "请检查账号格式":"Please check the account format",
    "绑定账号":"Bind account",
    "请输入右侧图片验证码":"Please enter the right picture verification code",
    "短信":"SMS",
    "邮箱或短信验证码":"Email or SMS verification code",
    "确认重置密码":"Confirm password reset",
    "验证":"Verification",
    "找回密码":"Retrieve password",
    "发送验证码失败，账户类型不对":"Failed to send verification code. The account type is incorrect",
    "重置密码":"Reset password",
    "密码修改成功请前去登陆":"The password has been modified successfully. Please go to login",
    "账号密码登录":"Account login",
    "手机短信登录":"SMS login",
    "快速注册登录":"Registration/Login",
    "请输入手机号":"Please enter your mobile number",
    "请输入短信验证码":"Please enter SMS verification code",
    "获取验证码":"Verification code",
    "请输入账号手机邮箱":"Please enter the account/mobile phone/email",
    "忘记密码":"Forget password",
    "没有账号":"No account?",
    "去注册":"To register?",
    "微信登录":"WeChat login",
    "注册登录":"Register/Login",
    "登录":"Sign in",
    "请输入用户名":"Enter user name",
    "请输入6位以上密码":"Please enter a password with more than 6 digits",
    "邮箱验证":"Mailbox verification",
    "短信验证":"SMS verification",
    "类型错误":"Error in type",
    "正在登录中":"Signing in...",
    "请输入正确格式的账号":"Please enter an account in the correct format",
    "密码强度过低":"Password strength is too low",
    "选择身份":"Select identity",
    "请输入或者选择学校":"Please enter or select a school",
    "立即注册":"Register now",
    "请选择实际身份":"Please select your actual role in teaching",
    "老师角色说明":"Create and manage courses, publish assignments/tests, manage students, view teaching data",
    "学生角色说明":"Join courses, complete assignments/tests, participate in class activities",
    "角色选择警示":"Your role cannot be changed easily after registration. Please choose correctly to avoid students registering as teachers.",
    "下一步":"Next",
    "返回修改身份":"Change role",
    "请先选择身份":"Please select a role first",
    "我已阅读并同意":"I have read and agree to",
    "用户服务协议":"Ketangpai Terms of Service",
    "请先同意用户服务协议":"Please read and agree to the Terms of Service",
    "手机号未注册请先注册":"This mobile number is not registered. Please register first.",
    "手机号快速注册":"Quick register with mobile",
    "普通注册":"Standard registration",
    "普通注册说明":"Register with email or mobile number and set a password",
    "手机号快速注册说明":"Mobile number only. Complete registration via SMS verification",
    "手机号已注册请登录":"This mobile number is already registered. Please log in.",
    "添加老师助教":"Add Teacher/Assistant",
    "老师助教":"Teacher/Assistant",
    "请输入课堂派账号手机邮箱":"Please enter Ketangpai account/phone number/email",
    "添加老师助教成功":"Successfully added teacher/assistant",
    "全部学生":"Students",
    "按标签":"By label",
    "机构选课名单":"Institution",
    "新建标签":"New label",
    "删除成员":"Delete Member",

}